import { render, staticRenderFns } from "./app-sub-header.vue?vue&type=template&id=4f8eb81c&scoped=true"
import script from "./app-sub-header.vue?vue&type=script&lang=js"
export * from "./app-sub-header.vue?vue&type=script&lang=js"
import style0 from "./app-sub-header.vue?vue&type=style&index=0&id=4f8eb81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8eb81c",
  null
  
)

export default component.exports